import { render } from "./indexRTL.vue?vue&type=template&id=7a635b70"
import script from "./indexRTL.vue?vue&type=script&lang=js"
export * from "./indexRTL.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__